import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import ContactSupport from '../components/ContactSupport';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF5F8] to-white">
      <Navbar />

      {/* Content */}
      <div className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-4xl">
          {/* Hero */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Terms of Service</h1>
            <p className="text-xl text-gray-600">
              Last updated: April 2026
            </p>
          </div>

          {/* Content */}
          <Card className="p-8 md:p-12 border-pink-100 shadow-lg">
            <div className="prose prose-lg max-w-none text-gray-700">
              <p className="mb-8">
                These Terms govern your use of Ovalu, a product of LabVIEWDevops.
              </p>

              <section className="mb-8 p-6 bg-pink-50 rounded-2xl border border-pink-100">
                <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="mr-2">⚠️</span> Medical Disclaimer
                </h2>
                <p className="italic leading-relaxed text-sm sm:text-base">
                  Ovalu is not a medical or diagnostic application. It is intended for informational and cycle tracking purposes only.
                  The predictions and insights provided by the app may not be 100% accurate and should not be relied upon for medical decisions.
                  Users are advised to consult a qualified healthcare professional for any medical concerns.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p>By using this app, you agree to these Terms.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Service Description</h2>
                <p>Ovalu provides menstrual cycle tracking and related insights for informational purposes.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. No Medical Advice</h2>
                <p>Ovalu is not a medical service. Users must consult professionals for medical guidance.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. User Responsibility</h2>
                <p>Users are responsible for the accuracy of the data they input.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Payments</h2>
                <p>All payments are processed via Razorpay. By purchasing, you agree to the pricing and billing terms.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Limitation of Liability</h2>
                <p>LabVIEWDevops is not responsible for any health decisions made based on app data.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Modifications</h2>
                <p>We may update these Terms at any time.</p>
              </section>
            </div>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Terms;
